import { Twist } from "../../../../models/SyntheticMap";
import { DragonflyAgent } from "../DragonflyAgent";
import { DragonflyController } from "./DragonflyController";
import * as THREE from 'three';

export class CameraController extends DragonflyController {
  computeTwist(dt: number): Twist | DragonflyController | string {
    // throw new Error("Method not implemented.");
    return 'Idle';
  }
  public isTracking = false;
  public targetId = ''; //'68bf2f9e9a92519dfaa53ac2';
  public targetObj?: THREE.Object3D;
  public staticLocation = new THREE.Vector3();
  public craft: THREE.Object3D;

  constructor(public agent: DragonflyAgent, public cameraGimbal: THREE.Object3D) {
    super();
    this.craft = cameraGimbal.parent!;
  }

  public setTargetId(id: string) {
    this.targetId = id;
    this.targetObj = undefined;
  }

  public getTarget() {
    if (this.targetId && !this.targetObj) {
      this.targetObj = this.agent.visual.wr.dataService.visuals.get(this.targetId)?.obj;
    }
    if (this.targetId && this.targetObj) {
      this.targetObj.updateMatrixWorld(true);
      return this.targetObj.position;
    }
    if (!this.targetId) {
      return this.staticLocation;
    }
    return null;
  }

  public render(delta: number) {
    if (!this.isTracking) {
      this.cameraGimbal.rotation.set(0, 0, 0);
      return;
    }
    const target = this.getTarget();
    if (!target) {
      this.cameraGimbal.rotation.set(0, 0, 0);
      return;
    }
    this.craft.updateMatrixWorld(true);
    const localTargetPos = this.refToCraft(target);
    let pan = Math.atan2(localTargetPos.y, localTargetPos.x);
    let tilt = Math.asin(localTargetPos.z / localTargetPos.length());
    // pan = lowPassFilter(this.cameraGimbal.rotation.z, pan, 0.75);
    // tilt = lowPassFilter(this.cameraGimbal.rotation.y, tilt, 0.75);
    this.cameraGimbal.rotation.set(0, -tilt, pan);
  }
}